// extracted by mini-css-extract-plugin
export default {"zoomModal":"C0-z","image":"D0-z","button":"E0-z","isOverlayShown":"F0-z"};